import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import FileSelectorButton from '@/components/Ui/FileSelectorButton'
import Constants from '@/utils/Constants'
import Utility from '@/utils/Utility'
import Jsonb from '@/utils/Jsonb'
import Validator from '@/utils/Validator'

export default {
  name: 'ContentsDesign',
  components: {
    FileSelectorButton
  },
  data () {
    return {
      input: {
        designIconMode: 0,
        defaultFontColor: null,
        focusFontColor: null,
        disableFontColor: null,
        defaultBtnStyle: {
          backgroundColor: null,
          transparency: 0,
          frameLineColor: null,
          frameLineWidth: 0
        },
        focusBtnStyle: {
          backgroundColor: null,
          transparency: 0,
          frameLineColor: null,
          frameLineWidth: 0,
          btnZoom: 100
        },
        disableBtnStyle: {
          backgroundColor: null,
          transparency: 0,
          frameLineColor: null,
          frameLineWidth: 0
        },
        slideImageAnimationAreaMargin: 0,
        defaultSlideImageAnimationArea: {
          framelineColor: null,
          frameLineWidth: 0
        },
        focusSlideImageAnimationArea: {
          framelineColor: null,
          frameLineWidth: 0
        },
        disableSlideImageAnimationArea: {
          framelineColor: null,
          frameLineWidth: 0
        },
        panelBackgroundColor: null,
        panelBackgroundTransparency: 0,
        btnRoundCornerUseFlg: 0,
        btnRectRoundCornerStyle: {
          roundCornerLeftTop: 0,
          roundCornerRightTop: 0,
          roundCornerLeftBottom: 0,
          roundCornerRightBottom: 0
        },
        badgeRoundCornerUseFlg: 0,
        badgeRectRoundCornerStyle: {
          roundCornerLeftTop: 0,
          roundCornerRightTop: 0,
          roundCornerLeftBottom: 0,
          roundCornerRightBottom: 0
        },
        thumbUpBtnlabel: null
      }
    }
  },
  mounted () {
    this.init()
  },
  computed: {
    ...mapState({
      categoryName: state => state.serviceContentsSetting.categoryName,

      // form
      serviceId: state => state.serviceContentsSettingForm.serviceId,
      serviceContentsId: state => state.serviceContentsSettingForm.targetId,
      values: state => state.serviceContentsSettingForm.values,
    }),
    ...mapGetters({
      permittedView: 'permission/permittedView',
      isRegister: 'serviceContentsSettingForm/isRegister',
      isModify: 'serviceContentsSettingForm/isModify',
    }),

    // list
    iconModeList () {
      return Constants.ServiceContents.DesignIconMode.sort(Utility.sortByKey('index', true))
    },
    buttonRoundCornerList () {
      return Constants.ServiceContents.ButtonRoundCorner.sort(Utility.sortByKey('index', true))
    },
    badgeRoundCornerList () {
      return Constants.ServiceContents.BadgeRoundCorner.sort(Utility.sortByKey('index', true))
    },

    // validate
    formIsValid () {
      const v1 = this.validate('designIconMode') &&
        this.validate('btnRoundCornerUseFlg') &&
        this.validate('badgeRoundCornerUseFlg') &&
        // フォントカラー設定
        this.validate('defaultFontColor') &&
        this.validate('focusFontColor') &&
        this.validate('disableFontColor') &&
        // ボタン設定
        this.validate('defaultBtnStyle.backgroundColor') &&
        this.validate('defaultBtnStyle.transparency') &&
        this.validate('defaultBtnStyle.frameLineColor') &&
        this.validate('defaultBtnStyle.frameLineWidth') &&
        this.validate('focusBtnStyle.backgroundColor') &&
        this.validate('focusBtnStyle.transparency') &&
        this.validate('focusBtnStyle.frameLineColor') &&
        this.validate('focusBtnStyle.frameLineWidth') &&
        this.validate('focusBtnStyle.btnZoom') &&
        this.validate('disableBtnStyle.backgroundColor') &&
        this.validate('disableBtnStyle.transparency') &&
        this.validate('disableBtnStyle.frameLineColor') &&
        this.validate('disableBtnStyle.frameLineWidth') &&
        // スライドショー・画像/動画エリア設定
        this.validate('slideImageAnimationAreaMargin') &&
        this.validate('defaultSlideImageAnimationArea.framelineColor') &&
        this.validate('defaultSlideImageAnimationArea.frameLineWidth') &&
        this.validate('focusSlideImageAnimationArea.framelineColor') &&
        this.validate('focusSlideImageAnimationArea.frameLineWidth') &&
        this.validate('disableSlideImageAnimationArea.framelineColor') &&
        this.validate('disableSlideImageAnimationArea.frameLineWidth') &&
        // パネル設定
        this.validate('panelBackgroundColor') &&
        this.validate('panelBackgroundTransparency') &&
        // いいねボタン設定
        this.validate('thumbUpBtnlabel')
      if (!v1) return false

      // ボタン角丸設定
      let v2 = false
      if (this.input.btnRoundCornerUseFlg === 1) {
        v2 = this.validate('btnRectRoundCornerStyle.roundCornerLeftTop') &&
        this.validate('btnRectRoundCornerStyle.roundCornerRightTop') &&
        this.validate('btnRectRoundCornerStyle.roundCornerLeftBottom') &&
        this.validate('btnRectRoundCornerStyle.roundCornerRightBottom')
      } else {
        v2 = true
      }
      if (!v2) return false

      // バッジ角丸設定
      let v3 = false
      if (this.input.badgeRoundCornerUseFlg === 1) {
        v3 = this.validate('badgeRectRoundCornerStyle.roundCornerLeftTop') &&
        this.validate('badgeRectRoundCornerStyle.roundCornerRightTop') &&
        this.validate('badgeRectRoundCornerStyle.roundCornerLeftBottom') &&
        this.validate('badgeRectRoundCornerStyle.roundCornerRightBottom')
      } else {
        v3 = true
      }
      if (!v3) return false

      return true
    },

    // jsonb
    getJsonb () {
      let jsonb = $.extend(true, {}, this.input)

      // ボタン角丸設定
      if (jsonb.btnRoundCornerUseFlg === 0) {
        delete jsonb.btnRectRoundCornerStyle
      }

      // バッジ角丸設定
      if (jsonb.badgeRoundCornerUseFlg === 0) {
        delete jsonb.badgeRectRoundCornerStyle
      }
      
      return jsonb
    },
  },
  watch: {
    // 入力値が変更されたらモジュール全体のバリデート結果をstoreに保持
    input: {
      handler: function (to) {
        this.setValidate({
          key: 'contentsDesign',
          value: this.formIsValid
        })
      },
      deep: true
    }
  },
  methods: {
    ...mapActions({

    }),
    ...mapMutations({
      setValidate: 'serviceContentsSettingForm/setValidate'
    }),

    init () {
      if (this.values.contentsDesign) {
        let data = $.extend(true, this.input, this.values.contentsDesign)
        this.$set(this, 'input', data)
      }
        
      this.setValidate({
        key: 'contentsDesign',
        value: this.formIsValid
      })
    },

    /**
     * ファイル
     */
    getInputNode (name) {
      let nodes = name.split('.')
      let origin = this.input
      let key
      nodes.forEach((item, index) => {
        if (index < nodes.length - 1) {
          origin = origin[item]
        } else {
          key = item
        }
      })
      return {
        parent: origin,
        key: key
      }
    },
    /**
     * ファイルの変更
     */
    changeFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, Jsonb.formatFile(props.data))
      console.log('changeFileFromSelector', data.parent[data.key])
    },
    /**
     * ファイルの削除
     */
    deleteFileFromSelector (props) {
      let data = this.getInputNode(props.name)
      this.$set(data.parent, data.key, null)
      console.log('deleteFileFromSelector', null)
    },

    validate (key) {
      let data = this.getInputNode(key)
      let value = data.parent[data.key]
      switch (key) {
        case 'designIconMode':
        case 'btnRoundCornerUseFlg':
        case 'badgeRoundCornerUseFlg':
          return Validator.validRadio(value)
        // フォントカラー設定
        case 'defaultFontColor':
        case 'focusFontColor':
        case 'disableFontColor':
        case 'defaultBtnStyle.backgroundColor':
        case 'defaultBtnStyle.transparency':
        case 'defaultBtnStyle.frameLineColor':
        case 'defaultBtnStyle.frameLineWidth':
        case 'focusBtnStyle.backgroundColor':
        case 'focusBtnStyle.transparency':
        case 'focusBtnStyle.frameLineColor':
        case 'focusBtnStyle.frameLineWidth':
        case 'disableBtnStyle.backgroundColor':
        case 'disableBtnStyle.transparency':
        case 'disableBtnStyle.frameLineColor':
        case 'disableBtnStyle.frameLineWidth':
        case 'slideImageAnimationAreaMargin':
        case 'defaultSlideImageAnimationArea.framelineColor':
        case 'defaultSlideImageAnimationArea.frameLineWidth':
        case 'focusSlideImageAnimationArea.framelineColor':
        case 'focusSlideImageAnimationArea.frameLineWidth':
        case 'disableSlideImageAnimationArea.framelineColor':
        case 'disableSlideImageAnimationArea.frameLineWidth':
        case 'panelBackgroundColor':
        case 'panelBackgroundTransparency':
        case 'btnRectRoundCornerStyle.roundCornerLeftTop':
        case 'btnRectRoundCornerStyle.roundCornerRightTop':
        case 'btnRectRoundCornerStyle.roundCornerLeftBottom':
        case 'btnRectRoundCornerStyle.roundCornerRightBottom':
        case 'badgeRectRoundCornerStyle.roundCornerLeftTop':
        case 'badgeRectRoundCornerStyle.roundCornerRightTop':
        case 'badgeRectRoundCornerStyle.roundCornerLeftBottom':
        case 'badgeRectRoundCornerStyle.roundCornerRightBottom':
        case 'thumbUpBtnlabel':
          return Validator.validText(value)
        case 'focusBtnStyle.btnZoom':
          return Validator.validateNumber(value, {
            min: 0,
            max: 120,
          })
      }
    },
  }
}
